// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"McD6Z","skeleton":"rWbJH","pulseSkeleton":"uvZYo","pulse":"LhrC2","skeletonArray":"uWdcq","skeletonWrapperDirection":"enDWq"};